<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>{{ $route.meta.title }}</h3>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>审单管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="true">
      <template slot="header">搜索</template>

      <el-form
        :model="search"
        label-width="96px"
        label-position="right"
        size="medium"
        @submit.native.prevent="onSearch()"
        ref="searchForm"
      >
        <div class="re-el-form__flex">
          <el-form-item label="客户名称" prop="customerName">
            <el-input placeholder="请输入客户名称" v-model="search.customerName" clearable />
          </el-form-item>
          <el-form-item label="项目" prop="projectName">
            <el-input placeholder="请输入项目名称" v-model="search.projectName" clearable />
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" native-type="submit" size="mini">搜索</el-button>
          <el-button @click="resetSearch()" size="mini">重置</el-button>
        </el-form-item>
      </el-form>
    </layout-panel>

    <layout-panel>
      <template slot="header">列表</template>

      <el-table :data="table" stripe highlight-current-row border style="width: 100%">
        <el-table-column prop="customer_name" label="客户名称" min-width="120" />
        <el-table-column prop="project_name" label="项目名称" min-width="200" />
        <el-table-column prop="project_number" label="项目编号" min-width="120" />
        <el-table-column prop="pending_review" label="待审核" min-width="100" align="center" />
        <el-table-column prop="review_failed" label="审核未通过" min-width="120" align="center" />
        <el-table-column prop="closed" label="已关闭" min-width="100" align="center" />
        <el-table-column prop="review_passed" label="审核通过" min-width="100" align="center" />
        <el-table-column label="操作" min-width="120" align="center">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.audit_by_project"
              type="primary"
              size="mini"
              @click="handleStartReview(scope.row)"
            >
              开始审单
            </el-button>
            <el-button v-else type="text" @click="handleViewBatch(scope.row)">
              查看批次
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination
          background
          @size-change="handleSizePageChange"
          @current-change="handleCurrentPageChange"
          :current-page="pagination.current_page"
          :page-sizes="[20, 50, 100, 200]"
          :page-size="pagination.per_page"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        />
      </div>
    </layout-panel>
  </div>
</template>

<script>
import table from '@core/mixins/table'

export default {
  mixins: [table],
  name: 'ProjectOrderReviewStatTable',
  data () {
    return {
      search: {
        customerName: '',
        projectName: '',
      },
    }
  },
  methods: {
    getTableData (params) {
      const requestParams = {
        customer_name: params.customerName || '',
        project_name: params.projectName || '',
        current_page: params.current_page || 1,
        per_page: params.per_page || 50,
      }

      Object.keys(requestParams).forEach((key) => {
        if (requestParams[key] === '') delete requestParams[key]
      })

      return request.page('getStatisticProjectAudit', requestParams)
    },
    handleStartReview (row) {
      // 后续如需对接“开始审单”，再补充跳转逻辑
      console.log('开始审单:', row)
    },
    handleViewBatch (row) {
      const query = {projectId: row.projectid}
      const cid = row.customerid != null ? row.customerid : row.customer_id
      if (cid != null && cid !== '') {
        query.customerId = cid
      }
      this.$router.push({
        path: '/customer/batch-order-review/table',
        query,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
</style>




// WEBPACK FOOTER //
// src/views/audit-task-setting/pages/ProjectOrderReviewStatTable.vue